var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"custom-badge-component",class:{ purple: _vm.color == 'purple' },attrs:{"show":"","variant":_vm.type}},[_vm._v(" "+_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }